import * as yup from 'yup';
import FormFieldType from 'src/shared/ui/components/Form/FormFieldFactory/FormFieldType';
import DailyCashClosureStatus from './DailyCashClosureStatus';
import { t } from 'src/shared/literals';
import { formatNumber } from 'src/shared/support/number';

const CASH_PAYMENT_TYPES = ['CASH_MONEY_COLLECTOR', 'CASH_BOX', 'BANK_CHECK'];

const DailyCashClosure = ({
  fields,
  user,
  employeeList,
  companyBankAccountList
}) => [
  {
    name: 'dailyCashClosureCode',
    validation: yup
      .date()
      .nullable(false)
      .required('fieldRequired'),
    type: FormFieldType.TEXT_FIELD,
    value: fields ? fields.dailyCashClosureCode : null,
    enabled: true,
    readonly: true
  },
  {
    name: 'date',
    validation: yup
      .date()
      .nullable(false)
      .required('fieldRequired'),
    type: FormFieldType.DATE,
    value: fields ? fields.date : null,
    enabled: true,
    readonly: true
  },
  {
    name: 'status',
    validation: yup
      .string()
      .nullable(false)
      .required('fieldRequired'),
    type: FormFieldType.SELECT,
    value: fields && fields.status ? fields.status.toLowerCase() : '',
    options: Object.keys(DailyCashClosureStatus).map((x) => {
      return { id: x, name: x };
    }),
    readonly:
      !user.scopes.includes('admin:daily-cash-closures') ||
      fields.status === 'VALIDATED',
    fullWidth: true
  },
  {
    name: 'employeeId',
    validation: yup
      .string()
      .nullable(false)
      .required('fieldRequired'),
    type: FormFieldType.SELECT,
    value: fields ? fields.employeeId : '',
    options: employeeList
      .map((x) => {
        if (x.id === fields.employeeId) {
          return {
            id: x.id,
            name: `${x.firstname} ${x.surnames} ${x.document}`
          };
        }
      })
      .filter((x) => x),
    fullWidth: true,
    readonly: true,
    enabled: true
  },
  {
    name: 'paymentTypeCode',
    validation: yup
      .string()
      .required('fieldRequired')
      .nullable(false),
    type: FormFieldType.TEXT_FIELD,
    value:
      fields && fields.paymentTypeCode
        ? t(fields.paymentTypeCode.toLowerCase())
        : '',
    readonly: true,
    fullWidth: true
  },
  {
    name: 'totalAmount',
    validation: yup
      .string()
      .nullable(false)
      .required('fieldRequired'),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.totalAmount ? formatNumber(fields.totalAmount) : 0,
    readonly: true,
    enabled:
      user.scopes.includes('admin:daily-cash-closures') ||
      fields.registeredAmount
  },
  {
    name: 'registeredAmount',
    validation: fields.registeredAmount
      ? yup.string()
      : yup
          .number()
          .nullable(false)
          .required('fieldRequired'),
    type: FormFieldType.TEXT_FIELD,
    value:
      fields && fields.registeredAmount
        ? formatNumber(fields.registeredAmount)
        : null,
    readonly: fields.registeredAmount,
    enabled: CASH_PAYMENT_TYPES.includes(fields.paymentTypeCode)
  },
  {
    name: 'registeredDifferenceAmount',
    validation: fields.registeredDifferenceAmount
      ? yup.string()
      : yup
          .number()
          .nullable(false)
          .required('fieldRequired'),
    type: FormFieldType.TEXT_FIELD,
    value:
      fields && fields.registeredDifferenceAmount
        ? formatNumber(fields.registeredDifferenceAmount)
        : 0,
    readonly: true,
    enabled: fields.registeredDifferenceAmount
  },
  {
    name: 'depositNumber',
    validation: yup
      .string()
      .nullable(false)
      .required('fieldRequired'),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.depositNumber ? fields.depositNumber : '',
    fullWidth: true,
    readonly: fields.depositNumber,
    enabled:
      CASH_PAYMENT_TYPES.includes(fields.paymentTypeCode) &&
      (user.scopes.includes('admin:daily-cash-closures') ||
        fields.registeredAmount)
  },
  {
    name: 'depositAmount',
    validation: yup
      .string()
      .nullable(false)
      .required('fieldRequired'),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.depositAmount ? fields.depositAmount : '',
    readonly: fields.depositAmount,
    enabled:
      CASH_PAYMENT_TYPES.includes(fields.paymentTypeCode) &&
      (user.scopes.includes('admin:daily-cash-closures') ||
        fields.registeredAmount)
  },
  {
    name: 'depositRegisteredAt',
    validation: yup
      .date()
      .nullable(false)
      .required('fieldRequired'),
    type: FormFieldType.DATE,
    value:
      fields && fields.depositRegisteredAt
        ? fields.depositRegisteredAt
        : new Date(),
    readonly: fields.depositRegisteredAt,
    enabled:
      CASH_PAYMENT_TYPES.includes(fields.paymentTypeCode) &&
      (user.scopes.includes('admin:daily-cash-closures') ||
        fields.registeredAmount)
  },
  {
    name: 'companyBankAccountId',
    validation: yup
      .string()
      .nullable(false)
      .required('fieldRequired'),
    type: FormFieldType.SELECT,
    value: fields ? fields.companyBankAccountId : '',
    options: companyBankAccountList.map((x) => {
      return {
        id: x.id,
        name: `${x.name}`
      };
    }),
    readonly: fields.companyBankAccountId,
    enabled:
      CASH_PAYMENT_TYPES.includes(fields.paymentTypeCode) &&
      (user.scopes.includes('admin:daily-cash-closures') ||
        fields.registeredAmount)
  },
  {
    name: 'comments',
    validation: yup.string().nullable(true),
    type: FormFieldType.TEXT_AREA,
    value: fields && fields.comments ? fields.comments : '',
    fullWidth: true,
    readonly: true
  },
  {
    name: 'newComment',
    validation: yup.string().nullable(true),
    type: FormFieldType.TEXT_AREA,
    fullWidth: true,
    value: fields && fields.newComment ? fields.newComment : ''
  }
];

export default DailyCashClosure;
